import { gql } from '@apollo/client';

const CONFIRM_ACTIONS = gql`mutation confirmActions(
	$supplierOrderId: Int!
	$performActions: [PerformActionInput]
) {
	incomingOrders {
		confirmActions(
			supplierOrderId: $supplierOrderId
			performActions: $performActions
		)
		{
			actionResponses {
				action
				success
				url
			}
		}
	}
}`;

export default CONFIRM_ACTIONS;